import ExoText from './ExoText.jsx';
import InteractiveMenuItem from './InteractiveMenuItem.jsx';
export default function MenuDispatcher(props) {
  const {
    index,
    itemText,
    newTab = false,
    href,
    submenuItems = [],
    megaMenu,
    type = 'link',
    externalCallback,
    current,
    menuType,
    options,
    isMobile,
    closeMegaMenuLabel,
  } = props;
  const megaMenuItems = megaMenu ? megaMenu?.megaMenuColumns : [];
  const { additionalLink } = megaMenu ? megaMenu.options : {};

  if (type === 'exoText') {
    return <ExoText itemText={itemText} />;
  }

  return (
    <InteractiveMenuItem
      index={index}
      current={current}
      itemText={itemText}
      newTab={newTab}
      href={href}
      type={type}
      submenuItems={submenuItems}
      megaMenuItems={megaMenuItems}
      additionalLink={additionalLink}
      externalCallback={externalCallback}
      menuType={menuType}
      options={options}
      isMobile={isMobile}
      closeMegaMenuLabel={closeMegaMenuLabel}
    />
  );
}
